<template>
    <div id="highTaskOngoing">
        <div id="headers">
            <img src="../../assets/images/img_31.png" alt="" @click="returnPage">
            <div class="headerText">任务详情</div>
        </div>
        <!-- 头部面板 -->
        <div class="ongoingTop">
            <div class="topPanel">
                <div class="lefts">
                    <span class="tit">剩余时间</span>
                    <span class="num">{{surplusTimes}}</span>
                </div>
                <div class="rights">+{{commentTask.tuser_price}}<span>元</span></div>
            </div>
        </div>
        <!-- 信息 -->
        <div class="icons">
            <img :src="appios.icon ? appios.icon : '../../assets/images/img_77.png'">
            <div class="iconsRight">
                {{commentTask.name}}
            </div>
        </div>
        <!-- 步骤 -->
        <!-- 评论详情 -->
        <div class="comment-content">
            <p class="step-desc">向导：在商店搜索下载应用、评论并截图，审核内容必须跟App Store评论一致</p>

            <p class="func-title">
                <template v-if="commentTask.keywords && commentTask.keywords.length > 0">   
                    <span class="common-style">标题包含关键词：</span> 
                    <span v-for="(item, index) in commentTask.keywords" :key="index" class="common-style private-style">{{ item }}</span>
                </template>
            </p>
            <div class="common-wraper">
                <input id="inputOne" :readonly="detail.templet_id" v-model="title" class="input-keyword" type="text" placeholder="标题">
                <span v-if="detail.templet_id" id="copyTagOne" @click="copyContent('#copyTagOne')" :data-clipboard-text="detail.title" class="copy-btn">复制</span>
                <span v-else id="copyTagOne" @click="copyContent('#copyTagOne')" data-clipboard-target="#inputOne" class="copy-btn">复制</span>
            </div>

            <p class="func-title" style="margin-top: 10px;">
                <template v-if="commentTask.keywordscontent && commentTask.keywordscontent.length > 0">
                    <span>内容包含关键词：</span>
                    <span v-for="(item, index) in commentTask.keywordscontent" :key="index" class="common-style private-style">{{ item }}</span>
                </template>
            </p>
            <div class="common-wraper">
                <textarea id="inputTwo" :readonly="detail.templet_id" v-model="content" class="input-keyword input-textarea" type="text" placeholder="内容"></textarea>
                <span v-if="detail.templet_id" id="copyTagTwo" @click="copyContent('#copyTagTwo')" :data-clipboard-text="detail.content" class="copy-btn">复制</span>
                <span v-else id="copyTagTwo" @click="copyContent('#copyTagTwo')" data-clipboard-target="#inputTwo" class="copy-btn">复制</span>
            </div>

            <!-- 上传截图 -->
            <div class="uploadPictures">
                <div class="title">
                    <span class="redLine"></span>
                    <span class="txt">上传截图</span>
                    <span class="redLine"></span>
                </div>

                <div class="pictureFathers">
                    <div class="picture">
                        <div class="example">
                            <img src="../../assets/images/commentTask_example.png" v-preview="'../../assets/images/commentTask_example.png'" alt="">
                            <span>示例图</span>
                        </div>
                        <div class="choiceImg">
                            <img :src="uploadPic[0].images" alt="">
                            <img v-if="uploadPic[0].show" src="../../assets/images/img_14.png">
                            <input type="file" @change="getimg($event,0)" accept="image/jpeg,image/png,image/jpg,image/gif">
                        </div>
                    </div>
                </div>
                <div class="pictureFathers">
                    <div class="picture">
                        <div class="example">
                            <img src="../../assets/images/commentTask_example2.png" v-preview="'../../assets/images/commentTask_example2.png'" alt="">
                            <span>示例图</span>
                        </div>
                        <div class="choiceImg">
                            <img :src="uploadPic[1].images" alt="">
                            <img v-if="uploadPic[1].show" src="../../assets/images/img_14.png">
                            <input type="file" @change="getimg($event,1)" accept="image/jpeg,image/png,image/jpg,image/gif">
                        </div>
                    </div>
                </div>

                <div class="explain">请参照示例图上传</div>
            </div>
        </div>


        <div class="oneBtn" @click="handleSubmit">提交审核</div>

        <div class="gap"></div>

        <popChoose @giveUp="giveUp" @notGiveUp="notGiveUp" v-show="choosePop"></popChoose>
    </div>
</template>

<script>
    import Clipboard from 'clipboard'
    import popChoose from '../../components/PopChoose.vue'

    import Headers from '../../components/headersL'
    export default {
        components:{
            Headers,
            popChoose
        },
        data() {
            return {
                headersText:'任务详情',

                choosePop:false,

                surplusTimes:'', // 剩余时间
                timers:null, // 计时器

                appios: {},
                commentTask: {},
                detail: {},

                // 要上传的数据
                images: [], // 截图
                title: '', // 评论标题
                content: '', // 评论内容
                show: true, // 是否显示传图的加按钮
                uploadPic: [
                    {show:true,images:''},{show:true,images:''}
                ], // 要上传的图片的一个预览
            }
        },
        mounted() {
            this.changeInitH();
            this.addVisible();
        },
        destroyed() {
            this.removeVisible();
        },
        methods: {
            // 封装 visibilitychange事件
            hiddens(){
                if(!document.hidden){ 
                    clearInterval(this.timers);
                    this.surplusTimes = '';
                    this.changeInitH();
                }
            },
            // 执行 visibilitychange事件
            addVisible(){
                var hidden, state, visibilityChange; 
                if (typeof document.hidden !== "undefined") {
                    hidden = "hidden";
                    visibilityChange = "visibilitychange";
                    state = "visibilityState";
                } else if (typeof document.mozHidden !== "undefined") {
                    hidden = "mozHidden";
                    visibilityChange = "mozvisibilitychange";
                    state = "mozVisibilityState";
                } else if (typeof document.msHidden !== "undefined") {
                    hidden = "msHidden";
                    visibilityChange = "msvisibilitychange";
                    state = "msVisibilityState";
                } else if (typeof document.webkitHidden !== "undefined") {
                    hidden = "webkitHidden";
                    visibilityChange = "webkitvisibilitychange";
                    state = "webkitVisibilityState";
                }
                document.addEventListener(visibilityChange, this.hiddens, false);
            },
            // 移除 visibilitychange事件
            removeVisible(){
                var hidden, state, visibilityChange; 
                if (typeof document.hidden !== "undefined") {
                    hidden = "hidden";
                    visibilityChange = "visibilitychange";
                    state = "visibilityState";
                } else if (typeof document.mozHidden !== "undefined") {
                    hidden = "mozHidden";
                    visibilityChange = "mozvisibilitychange";
                    state = "mozVisibilityState";
                } else if (typeof document.msHidden !== "undefined") {
                    hidden = "msHidden";
                    visibilityChange = "msvisibilitychange";
                    state = "msVisibilityState";
                } else if (typeof document.webkitHidden !== "undefined") {
                    hidden = "webkitHidden";
                    visibilityChange = "webkitvisibilitychange";
                    state = "webkitVisibilityState";
                }
                document.removeEventListener(visibilityChange, this.hiddens, false);
            },
            // 封装执行函数
            changeInitH(){
                if(this.$route.query.ids){
                    this.init();
                } else {
                    this.$toast('请返回高额任务页重新进入该页面')
                }
            },
            // 请求初始化(数据展示)
            init(){
                this.$loading(true);
                let datas = {
                    task_id:this.$route.query.ids
                }
                this.$http.POSTS('comment_task/detail',datas,(res)=>{
                    console.log(res.data)
                    this.appios = res.data.appios;
                    this.commentTask = res.data.commentTask;
                    this.detail = res.data.detail;
                    this.countDownFun(res.data.detail.remain_time);
                    if(this.detail.title) {
                        this.title = this.detail.title;
                    }
                    if(this.detail.content) {
                        this.content = this.detail.content;
                    }
                    this.$loading(false);                   
                });
            },
            // 封装倒计时
            countDownFun(taskEndTime){
                if(taskEndTime <= 0){
                    this.surplusTimes = '00:00'
                    clearInterval(this.timers)
                } else {
                    this.timeFormat(taskEndTime);
                    this.timers = setInterval(()=>{
                        taskEndTime--;

                        if(taskEndTime <= 0){
                            this.surplusTimes = '00:00'
                            clearInterval(this.timers)
                        } else {
                            this.timeFormat(taskEndTime);
                        }
                        
                    },1000)
                }
            },
            timeFormat(taskEndTime){
                let endTimeMinute = Math.floor(taskEndTime/60%60);
                let endTimeSecond = Math.floor(taskEndTime%60);
                endTimeMinute = endTimeMinute>=10?endTimeMinute:'0'+endTimeMinute;
                endTimeSecond = endTimeSecond>=10?endTimeSecond:'0'+endTimeSecond;
                this.surplusTimes = endTimeMinute+':'+endTimeSecond;
            },

            // 进入 提交审核
            inSubmitAudit:function(){
                this.$router.push({name:'commentSubmitAudit',query: {ids:this.$route.query.ids,icons:this.detailData.icon}});
            },

            // 复制方法
            // 
            copyContent(selector) {
                let clipboard = new Clipboard(selector)
                clipboard.on('success', e => {
                    console.log(e)
                    this.$toast('复制成功')
                    // 释放内存
                    clipboard.destroy()
                })
                clipboard.on('error', e => {
                    console.log(e)
                    // 不支持复制
                    this.$toast('该浏览器不支持自动复制，请长按进行复制')
                    // 释放内存
                    clipboard.destroy()
                })
            },
            // 封装一个base64转file的函数
            base64ToFile(dataurl, filename) {
                //将base64转换为文件
                var arr = dataurl.split(','), mime = arr[0].match(/:(.*?);/)[1],
                    bstr = atob(arr[1]), n = bstr.length, u8arr = new Uint8Array(n);
                while(n--){
                    u8arr[n] = bstr.charCodeAt(n);
                }
                return new File([u8arr], filename, {type:mime});
            },
            // 封装一个Blob转base64的函数
            blobToBase64(blobObj) {
                return new Promise((resolve, reject) => {
                    let fr = new FileReader();
                    if(blobObj instanceof Blob) {
                        fr.readAsDataURL(blobObj);
                        fr.onload = function() {
                            resolve(this.result);
                        }
                    }
                });  
            },
            // 封装一个图片压缩函数
            compressImg(img_path, params_quality) {
                console.log("get in and start compress");
                var img = new Image();
                img.src = img_path;
                return new Promise((resolve, reject) => {
                    img.onload = function(){
                        var w = this.width,
                            h = this.height,
                            scale = w / h;
                        w = params_quality.w || w;
                        h = params_quality.h || h;

                        //创建canvas
                        var canvas = document.createElement('canvas');
                        var ctx = canvas.getContext('2d');
                        canvas.width = w;
                        canvas.height = h;
                        ctx.drawImage(this, 0, 0, w, h);

                        var quality = 0.7;
                        if(params_quality.quality && params_quality.quality > 0 && params_quality.quality <= 1){
                            quality = params_quality.quality;
                        }
                        var base64_temp = canvas.toDataURL('image/jpeg', quality);
                        //返回压缩后的图片的base64
                        resolve(base64_temp);
                    }
                });
            },
            // 上传图片
            getimg(e,index) {
                let that = this;
                var files = e.target.files[0];
                // 如果图片大小大于2M则开启压缩
                if(files.size > 1024 * 1024 * 1) {
                    this.blobToBase64(files).then((res) => {
                        this.compressImg(res, { quality: 0.6 }).then((res) => {
                            let file = this.base64ToFile(res, files.name);
                            this.images[index] = file;
                        });
                    });
                }else {
                    this.images[index] = files;
                }

                console.log(this.images)

                if (!e || !window.FileReader) return; // 看支持不支持FileReader

                if(files){
                    let reader = new FileReader();
                    reader.readAsDataURL(files);  // 读取文件
                    reader.onloadend = function() {
                        that.uploadPic[index].show=false;
                        that.uploadPic[index].images = this.result;
                    };
                }
            },


            handleSubmit() {
                if(!this.images || !this.content || !this.title) {
                    this.$toast('请完善资料后上传！');
                    return;
                }
                console.log(this.images, this.content, this.title)
                
                let formData = new FormData();
                formData.append('d_task_id', this.detail.id);
                formData.append('title', this.title);
                formData.append('content', this.content);
                for(var j=0;j<this.images.length;j++){
                    formData.append("images"+j,this.images[j]);
                }

                this.$loading(true);
                this.$http.POSTS('comment_task/submit', formData, (res) => {
                    this.$loading(false);
                    this.$toast(res.data);
                    setTimeout(() => {
                        this.$router.push('/commentTask');
                    }, 1500)
                })
            },
            // 返回
            returnPage:function(){
                // this.$router.go(-1);
                if(this.$route.query.ids){
                    this.choosePop = true;
                    // clearInterval(this.timers)
                } else {
                    this.$router.go(-1);
                    clearInterval(this.timers)
                }
            },
            // 弹窗
                // 放弃任务
            giveUp:function(){
                let datas = {
                    task_id:this.$route.query.ids
                }
                this.$http.POSTS('comment_task/untask',datas,(res)=>{
                    this.choosePop = false
                    this.$router.go(-1);
                });
            },
                // 不放弃任务
            notGiveUp:function(){
                console.log("不放弃")
                this.choosePop = false
            }
        },
    }
</script>

<style lang="less" scoped>
    #highTaskOngoing{
        // 导航栏
        #headers{
            width: 375px;
            height: 45px;
            background: linear-gradient(to right,#EB3F47,#E50113);
            display: flex;
            align-items: center;
            justify-content: center;
            position: relative;
            img{
                width: 11px;
                height: 18px;
                position: absolute;
                left: 15px;
                padding: 0 3px;
            }
            .headerText{
                font-size: 15px;
                color: #FFFFFF;
            }
        }
        // 头部面板
        .ongoingTop{
            width:375px;
            height:35px;
            background:linear-gradient(313deg,rgba(229,1,19,1) 0%,rgba(235,63,71,1) 100%);
            .topPanel{
                width:345px;
                height:60px;
                background:rgba(255,255,255,1);
                box-shadow:0px 5px 10px 0px rgba(0,0,0,0.05);
                border-radius:5px;
                border:1px solid rgba(222,222,222,.6);
                margin: 0 15px;
                position: relative;
                top: 8px;
                display: flex;
                align-items: center;
                justify-content: space-between;
                .lefts{
                    margin-left: 30px;
                    .tit{
                        font-size:15px;
                        color:rgba(51,51,51,1);
                        line-height:15px;
                    }
                    .num{
                        margin-left: 10px;
                        font-size:20px;
                        color:rgba(51,51,51,1);
                        line-height:20px;
                    }
                }
                .rights{
                    margin-right: 22px;
                    font-size:35px;
                    // font-family: Arial, Helvetica, sans-serif;
                    font-family:'Qds';
                    color:rgba(230,9,26,1);
                    line-height:42px;
                    font-weight: bold;
                    position: relative;
                    top: 4px;
                    span{
                        font-size: 14px;
                    }
                }
            }
        }
        // 信息
        .icons{
            width:315px;
            background:rgba(255,255,255,1);
            box-shadow:0px 5px 10px 0px rgba(0,0,0,0.05);
            border-radius:5px;
            border:1px solid rgba(222,222,222,.6);
            margin: 48px 15px 0;
            padding: 15px;
            display: flex;
            align-items: center;
            img{
                width: 60px;
                height: 60px;
                border-radius: 12px;
            }
            .iconsRight{
                margin-left: 10px;
                font-size: 20px;
                flex-grow: 1;
            }
        }
        // 步骤
        .step{
            width:315px;
            background:rgba(255,255,255,1);
            box-shadow:0px 5px 10px 0px rgba(0,0,0,0.05);
            border-radius:5px;
            border:1px solid rgba(222,222,222,.6);
            margin: 15px;
            display: flex;
            flex-direction: column;
            align-items: center;
            padding: 0 15px;
            .title{
                width:130px;
                height:32px;
                background:rgba(249,249,249,1);
                border-radius:0px 0px 8px 8px;
                border:1px solid rgba(222,222,222,.6);
                font-size:13px;
                font-weight:600;
                color:rgba(102,102,102,1);
                line-height:32px;
                text-align: center;
                margin-top: -1px;
            }
            .explain{
                font-size:13px;
                font-weight:400;
                color:rgba(51,51,51,1);
                line-height:20px;
                margin-top: 20px;
            }
            .diagram{
                width: 100%;
                display: flex;
                justify-content: center;
                margin: 10px 0;
                img{
                    width:90px;
                    height:160px;
                    padding: 0 10px;
                }
            }
            .enlarge{
                font-size:13px;
                font-weight:400;
                color:rgba(153,153,153,1);
                line-height:20px;
                padding: 0 0 10px;
            }
        }
        .oneBtn{
            width:250px;
            height:45px;
            background:linear-gradient(313deg,rgba(229,1,19,1) 0%,rgba(235,63,71,1) 100%);
            box-shadow:0px 5px 10px 0px rgba(229,1,19,0.15);
            border-radius:25px;
            font-size:15px;
            font-weight:500;
            color:rgba(255,255,255,1);
            line-height:45px;
            text-align: center;
            margin: 20px auto;
        }
        .gap{
            width: 100%;
            height: 15px;
        }
        .comment-content {
            width:315px;
            background:rgba(255,255,255,1);
            box-shadow:0px 5px 10px 0px rgba(0,0,0,0.05);
            border-radius:5px;
            border:1px solid rgba(222,222,222,.6);
            margin: 16px 15px 0;
            padding: 15px;
            .step-desc {
                font-size: 14px;
                font-family: PingFangSC-Medium,PingFang SC;
                font-weight: 500;
                color: rgba(84,84,84,1);
                line-height: 26px;
                margin: 0;
                margin-bottom: 24px;
            }
            .func-title {
                font-size: 16px;
                font-family: PingFangSC-Regular,PingFang SC;
                font-weight: 400;
                color: rgba(30,30,30,1);
                line-height: 16px;
                margin: 0;
                margin-bottom: 10px;
                display: flex;
                justify-content: flex-start;
                align-items: center;
                flex-wrap: wrap;
                .common-style {
                    margin-right: 12px;
                }
                .private-style {
                    font-size: 14px;
                    font-family: PingFangSC-Regular,PingFang SC;
                    font-weight: 400;
                    color: rgba(81,146,245,1);
                    line-height: 14px;
                    border-radius: 100px;
                    border: 1px solid rgba(81,146,245,1);
                    padding: 5px 11px;
                }
            }
            .common-wraper {
                background-color: rgba(74, 144, 226, 0.0722);
                border-radius: 4px;
                box-sizing: border-box;
                padding: 15px;
                display: flex;
                justify-content: space-between;
                align-items: center;
                .input-keyword {
                    border: none;
                    outline: 0;
                    appearance: none;
                    background-color: rgba(0, 0, 0, 0);
                    font-size: 14px;
                    font-family: PingFangSC-Regular,PingFang SC;
                    font-weight: 400;
                    color: rgba(153,153,153,1);
                    line-height: 14px;
                    width: 228px;
                }
                .input-keyword::placeholder {
                    font-size: 14px;
                    font-family: PingFangSC-Regular,PingFang SC;
                    font-weight: 400;
                    color: rgba(153,153,153,1);
                    line-height: 14px;
                }
                .copy-btn {
                    font-size: 16px;
                    font-family: PingFangSC-Medium,PingFang SC;
                    font-weight: 500;
                    color: rgba(74,144,226,1);
                    line-height: 16px;
                }
                .input-textarea {
                    height: 50px;
                }
            }
        }
        // 上传截图
        .uploadPictures{
            margin: 0 20px;
            margin-top: 32px;
            display: flex;
            flex-direction: column;
            align-items: center;
            .title{
                display: flex;
                align-items: center;
                justify-content: center;
                margin-bottom: 6px;
                .redLine{
                    display: inline-block;
                    width:10px;
                    height:3px;
                    background:rgba(229,1,19,1);
                    border-radius:2px;
                    margin: 0 5px;
                }
                .txt{
                    font-size:15px;
                    font-weight:600;
                    color:rgba(21,21,21,1);
                    line-height:15px;
                }
            }
            .pictureFathers{
                width: 100%;
                .picture{
                    width: 100%;
                    display: flex;
                    justify-content: space-around;
                    padding-top: 10px;
                    .example{
                        display: flex;
                        flex-direction: column;
                        align-items: center;
                        img{
                            width: 90px;
                            height: 160px;
                        }
                        span{
                            font-size:15px;
                            font-weight:600;
                            color:rgba(21,21,21,1);
                            line-height:15px;
                            margin-top: 11px;
                        }
                    }
                    .choiceImg{
                        width: 90px;
                        height: 160px;
                        position: relative;
                        img{
                            width: 100%;
                            height: 100%;
                            position: absolute;
                            display: block;
                            top:0;
                            left: 0;
                        }
                        input {
                            display: block;
                            width: 100%;
                            height: 100%;
                            opacity: 0;
                            z-index: 10000;
                        }
                    }
                    
                }
            }
            
            .btn{
                width:250px;
                height:45px;
                background:linear-gradient(313deg,rgba(229,1,19,1) 0%,rgba(235,63,71,1) 100%);
                box-shadow:0px 5px 10px 0px rgba(229,1,19,0.15);
                border-radius:25px;
                font-size:15px;
                font-weight:500;
                color:rgba(255,255,255,1);
                line-height:45px;
                text-align: center;
                margin: 30px 0 30px;
            }
            .explain{
                font-size:13px;
                font-weight:400;
                color:rgba(153,153,153,1);
                line-height:20px;
                padding-bottom: 15px;
                margin-top: 16px;
            }
        }
    }
</style>